import type { InterventionTabDetailsProps } from "./intervention-tab-details.type";

import InterventionTabDetails from "./intervention-tab-details.component";

export type { InterventionTabDetailsProps };
export default InterventionTabDetails;
